export default __webpack_public_path__ + "static/media/slice-app.091155c4.jpg";